import { createContentPropTypes } from '../../../../helpers/content';

const content = {
	header: 'Payment details',
	headerEdit: 'Edit Payment Details',
	description:
		'Once you’ve entered the payment details below, we’ll show you an indicative exchange rate and any fees you’ll be charged as well as the earliest estimated settlement date.',
	ideaHowMuchPaymentWillCost:
		'This will give you an idea of how much the payment will cost and when it’ll be sent to the payee’s account.',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
